<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count= 'count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>商品:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.serialCodeOrName"></lk-input>
          </div>
          <div class="queryItem">
            <label>库存日期:</label>
            <timeStampDatePicker  v-model='query.queryDate' :options='createTimeStartOption' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="gotoHandleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
  </template>

<script>

import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import service from '../../../services/lgq/services';

export default {
  name: 'inventorySummaryTable',
  mixins: [mapState, queryMixins],
  data() {
    return {
      size: 20,
      query: {
        serialCodeOrName: '',
        queryDate: '',
      },
      columns: [
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '通用名', key: 'approvedName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '单位', key: 'minPkgUnit', minWidth: 116 },
        { title: '总数量', key: 'num', minWidth: 116 },
        { title: '已销售数量', key: 'saledNum', minWidth: 116 },
        { title: '批号', key: 'batchCode', minWidth: 116 },
        { title: '批次', key: 'batchSeq', minWidth: 116 },
        {
          title: '有效期',
          key: 'expiryDate',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.expiryDate)),
        }],
      tableData: [],
      createTimeStartOption: this.createTimeStartOptions(),
    };
  },
  methods: {
    createTimeStartOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > new Date();
        },
      };
    },
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      service.inventorySummary(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list;
          this.count = res.data.data.count || 0;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    gotoHandleSearch() {
      this.handleSearch();
    },
    clear() {
      this.query = {
        serialCodeOrName: '',
        queryDate: '',
      };
    },
  },
  mounted() {
    this.handleSearch(true);
  },
  components: {
    QueryFrame,
  },
};
</script>

<style scoped>
</style>
